// extracted by mini-css-extract-plugin
export var footer = "_n9-5";
export var fulfillmentInput = "_n9-0";
export var shipDateInput = "_n9-1";
export var shipmentModal = "_n9-2";
export var shipmentModalContent = "_n9-3";
export var tableContainer = "_n9-4";